import React from "react";

function PrivacyPage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        padding: "32px"
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          background: "#fff",
          borderRadius: "20px",
          padding: "24px",
          boxShadow: "0 10px 40px rgba(0,0,0,0.08)"
        }}
      >
        <h1>Privacy Policy</h1>

        <p style={{ color: "#6b7280" }}>
          View or download the official Ecovanta / Onedigitale Privacy Policy.
        </p>

        <div style={{ marginBottom: "16px" }}>
          <a href="/legal/privacy-policy.pdf" target="_blank" rel="noreferrer">
            Open PDF in new tab
          </a>
          {" • "}
          <a href="/legal/privacy-policy.pdf" download>
            Download PDF
          </a>
        </div>

        <iframe
          src="/legal/privacy-policy.pdf"
          title="Privacy Policy"
          style={{
            width: "100%",
            height: "80vh",
            border: "1px solid #e5e7eb",
            borderRadius: "12px"
          }}
        />

        <div style={{ marginTop: "24px" }}>
          <a href="/">← Back to Ecovanta</a>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;